import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnnuaireResultCorrespondant } from 'src/app/utils/interfaces/new/annuaire-result-correspondant.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-info-correspondant',
  templateUrl: './info-correspondant.fragment.html',
  styleUrls: [
    './info-correspondant.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class InfoCorrespondantFragment implements OnInit {

  public correspondantInfos: AnnuaireResultCorrespondant;
  public specialiteName: string;

  @Output() public closeEmitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeAlertModal();
  }

  getMails(mails?: string) {
    if (mails && mails.length > 0) {
      if (mails.includes(',')) {
        const mailArr = mails.split(',');
        mailArr.pop();
        let result = '';
        for (const mail of mailArr) {
          result += '\n' + mail;
        }
        return result;
      } else {
        return mails;
      }
    } else {
      return '- -';
    }
  }

  public closeAlertModal(obj?: AnnuaireResultCorrespondant): void {
    this.closeEmitter.emit(obj);
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

}
